import React from 'react';
import CheckEmailScreen from './CheckEmailScreen';
import { useAuth } from '../../context/AuthContext';
import { signInGate } from '../../domain/signIn';

// Nobody whose email address is unconfirmed gets past this (#566): they see
// the check-your-email screen and nothing else, on every path, until
// Firebase says the address is verified. The rule is src/domain/signIn.js.
//
// Placed in src/App.jsx above every data provider rather than inside
// RequireAuth, so "nothing else" is literal. A gate drawn per route would still
// have mounted the studio's providers, which open their listeners the moment
// there is a user; here there is nothing below to open them. Still loading,
// and signed out, pass through: RequireAuth and the router already answer
// those.
export default function SignInGate({ children }) {
  const { user, loading, emailVerified, isConfigured } = useAuth();
  if (!isConfigured) return children;
  return signInGate({ loading, user, emailVerified }) === 'verify-email'
    ? <CheckEmailScreen />
    : children;
}
